import { connect } from 'react-redux';
import { StoreState } from '../../../../redux/reducers/store.types';
import { Dispatch } from '../../../../redux/redux.types';
import { getJobBasedOperation } from '../common/compress/job-based-group.selectors';
import { closeOperationGroup } from '../operation-groups.actions';
import {
  DispatchProps,
  DownloadGroup,
  OwnProps,
  StateProps,
} from './download-group';

const mapStateToProps = (state: StoreState, ownProps: OwnProps) => ({
  operation: getJobBasedOperation(state, ownProps.groupId),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    closeGroup: (groupId: string) => dispatch(closeOperationGroup(groupId, [])),
  };
};

export const DownloadGroupContainer = connect<
  StateProps,
  DispatchProps,
  OwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(DownloadGroup);
